import FrontPageHero from "./FrontPageHero";

export default FrontPageHero;
